import React, { memo } from 'react';
import { SlidersHorizontalIcons } from '../../../../../../icons/icons';
import { ActionButton } from './ActionButton';
import { TableViewControlsProps } from './interfaces';

export const TableViewControls = memo<TableViewControlsProps>(({ handleColumnConfig }) => (
  <ActionButton
      onClick={handleColumnConfig}
      icon={<SlidersHorizontalIcons size={14} />}
      label='Columns'
      title='Configure table columns'
  />
));

TableViewControls.displayName = 'TableViewControls';
